import {
  Component, ViewChild, ViewContainerRef, ComponentFactoryResolver, ComponentRef,
  AfterContentInit, OnDestroy, ElementRef
} from '@angular/core';
import { columnDragComponent } from './columnDrag.component';
import { mainViewComponent } from './main-view.component';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'widget',
  templateUrl: 'widget-container.template.html'
})

export class widgetContainerComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  @ViewChild('container', { read: ViewContainerRef, static: true })
  container: ViewContainerRef;

  public widget: ComponentRef<any>;

  public mainViewComponent: mainViewComponent;

  public position: number = 0;
  public isLast: boolean = false;
  private editMode: boolean = false;

  private columnContainer: columnDragComponent;

  reloadSubject: Observable<boolean>;

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
    private elementRef: ElementRef) {
    super();
  }

  ngAfterContentInit() {
    if (this.mainViewComponent) {
      this.subscribe(this.mainViewComponent.editModeObservable,
        mode => {
          this.editMode = mode;
        });
    }
  }

  ngOnDestroy() {
    // eliminar referencias que se establecen en columnDragComponent para liberar memoria
    this.widget = undefined;
    this.mainViewComponent = undefined;
    this.columnContainer = undefined;
    super.ngOnDestroy();
  }

  public insertWidget(widgetComponent: any, params: any, parent: columnDragComponent) {
    this.columnContainer = parent;
    let factory = this.componentFactoryResolver.resolveComponentFactory(widgetComponent);
    this.widget = this.container.createComponent(factory);
    this.widget.instance['filters'] = params['filters'];
    this.widget.instance['reloadSubject'] = this.reloadSubject;
    this.elementRef.nativeElement.className = params.id;
  }


  cols(): string {
    return 'col-12 col-md-' + (12 / this.columnContainer.components.length);
  }

  panelStyle(): any {
    if (this.columnContainer && this.columnContainer.caluclateNumColumns() == 1) {
      return {
        'z-index': '3',
        'position': 'absolute',
        'text-align': 'center',
        'height': '102%',
        'width': '0',
        'left': '50%',
        'top': '-1%'
      };
    } else {
      return {
        'z-index': '3',
        'position': 'absolute',
        'width': '104%',
        'top': '3em',
        'left': '-2%'
      };
    }
  }

  leftStyle(): any {
    if (this.columnContainer && this.columnContainer.caluclateNumColumns() === 1) {
      return {
        'transform': 'rotate(90deg)'
      };
    } else {
      return {
        'float': 'left'
      };
    }
  }

  rightStyle(): any {
    if (this.columnContainer && this.columnContainer.caluclateNumColumns() === 1) {
      return {
        'bottom': '0px',
        'position': 'absolute',
        'transform': 'rotate(90deg)'
      };
    } else {
      return {
        'float': 'right'
      };
    }
  }
}